export const getTruckTypeColor = (truckType = '') => {
  const colors = [
    '#2563eb', // blue
    '#16a34a', // green
    '#dc2626', // red
    '#9333ea', // purple
    '#ea580c', // orange
    '#0891b2', // cyan
    '#ca8a04', // yellow
    '#be123c', // rose
  ];

  const hash = truckType
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);

  return colors[hash % colors.length];
};
